import { apiFetch } from './client';
import type { Policy } from '$lib/types';

export interface PolicyBody {
  title: string;
  body: string;
}

export const policiesApi = {
  get: (slug: string) => apiFetch<Policy>(`/policies/${slug}`),
  update: (slug: string, body: PolicyBody) =>
    apiFetch<Policy>(`/policies/${slug}`, { method: 'PUT', body: JSON.stringify(body) })
};
